import { Component, inject, OnInit } from '@angular/core';
import { EventsSummaryComponent } from '../../../events/summary/feature/summary.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { selectBookingPayment, selectEventBooking } from '../../../data-services/stores/selectors/user.selectors';
import { AsyncPipe, CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { HeadlineComponent } from '../../../events/headline/feature/headline.component';
import { TicketPillComponent } from '../../../events/book/ticket-pill/feature/ticket-pill.component';
import { EventBookingDetailed } from '../../../data-services/models/event-bookings/event-booking-detailed.model';
import { EventBookingComplete } from '../../../data-services/models/event-bookings/event-booking-complete.model';
import { PaypalComponent } from '../../../core/paypal/feature/paypal.component';
import { PaymentData } from '../../../data-services/models/payments/payment.model';
import { Title } from '@angular/platform-browser';
import { tap } from 'rxjs';

@Component({
  selector: 'app-show-event-booking',
  imports: [CommonModule,HeadlineComponent,TicketPillComponent,PaypalComponent],
  templateUrl: '../ui/show-event-booking.component.html',
  styleUrl: '../ui/show-event-booking.component.css'
})
export class ShowEventBookingComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);
  
  eventName?:string;


  eventBooking$ = this._store.select(selectEventBooking(this._route.snapshot.params["id"])).pipe(tap(x => 
    this.eventName = x?.event.name
  ));
  payment$ = this._store.select(selectBookingPayment(this._route.snapshot.params["id"]));
  primaryTicketArray: string[] = ['Player','Player (Under 16)','Crew','Crew (Under 16)','Staff'];

  ngOnInit(): void {
    this._titleService.setTitle('LRPTickets.co.uk | My Event Booking | ' + this.eventName)
  }

  getPrimaryTicket(eventBooking: EventBookingComplete){
    const primaryIndex = eventBooking.eventTickets.findIndex(x => this.primaryTicketArray.includes(x.name))
    return eventBooking.eventTickets[primaryIndex];
  }

  getEventTickets(eventBooking: EventBookingComplete){
    return eventBooking.eventTickets.filter(x => !this.primaryTicketArray.includes(x.name))
  }

  getTotalCost(eventBooking: EventBookingComplete){
    return eventBooking.eventTickets.flatMap(x => x.cost).reduce((acc, val) => acc + val, 0) + (eventBooking.event.organiser?.partnerFee ?? 0)
  }

  getPaymentDataID(paymentData: PaymentData[]){
    return paymentData.find(x => x.paymentProviderFieldID === 2)
  }

  getPaymentDataReference(paymentData: PaymentData[]){
    return paymentData.find(x => x.paymentProviderFieldID === 3)
  }

  getPaymentDataOrder(paymentData: PaymentData[]){
    return paymentData.find(x => x.paymentProviderFieldID === 1)
  }

}
